import * as _ from 'lodash'
import * as React from 'react'
import { Badge, Col, Row } from 'reactstrap';
import { DataList, DataListRowLink } from '../../../../components/ui/DataList';
import { IHierarchyReference, IHierarchyStudies, IProject, ISurveyReference } from '../../interfaces';

interface IPairHierarchysAndSurveysProps {
  project: string
  selectedHierarchys: IHierarchyReference[]
  selectedSurveys: ISurveyReference[]
  onChange: (values: IHierarchyStudies[]) => void
  values: IHierarchyStudies[]
}

interface IPairHierarchysAndSurveysState {
  selectedHierarchyAvid: string
}

export class PairHierarchysAndSurveys extends React.Component<IPairHierarchysAndSurveysProps, IPairHierarchysAndSurveysState> {
  state: IPairHierarchysAndSurveysState = {
    selectedHierarchyAvid: ''
  }

  componentWillMount() {
    const { project, selectedHierarchys } = this.props
    const selectedHierarchyAvid = selectedHierarchys[0].avid

    this.setState({ selectedHierarchyAvid })
    this.checkForDepreciatedValues()
  }

  checkForDepreciatedValues() {
    let newValues = [...this.props.values]
    const { selectedHierarchys, selectedSurveys } = this.props
    const preFilterLength = newValues.length

    newValues = newValues.filter((value) => {
      const hasHierarchy = selectedHierarchys.some((h) => h.avid === value.avid)
      const hasSurvey = selectedSurveys.some((s) => s.surveyNewAbbreviation === value.surveyAbbr)

      return hasHierarchy && hasSurvey
    })

    const postFilterLength = newValues.length

    if (postFilterLength !== preFilterLength) {
      this.props.onChange(newValues)
    }
  }

  togglePair(survey: ISurveyReference) {
    const { selectedHierarchyAvid } = this.state
    const values = [...this.props.values]
    const surveyIndex = values.findIndex((v) =>
      v.surveyAbbr === survey.surveyNewAbbreviation && v.avid === selectedHierarchyAvid
    )

    if (surveyIndex >= 0) {
      values.splice(surveyIndex, 1)
    } else {
      values.push({
        avid: selectedHierarchyAvid,
        surveyAbbr: survey.surveyNewAbbreviation
      })
    }

    this.props.onChange(values)
  }

  getAvidLength(avid: string) {
    const { values } = this.props

    const studies = values.filter((value) => value.avid === avid)

    return studies.length
  }

  isChecked(survey: ISurveyReference) {
    const { selectedHierarchyAvid } = this.state
    const { values } = this.props
    const studies = values.filter((value) => value.avid === selectedHierarchyAvid)

    return studies.findIndex((s) => s.surveyAbbr === survey.surveyNewAbbreviation) >= 0
  }

  render() {
    const { selectedSurveys, selectedHierarchys } = this.props

    return (
      <Row>
        <Col xs={5}>
          <DataList>
            {selectedHierarchys.map((hierarchy, index) =>
              <DataListRowLink key={hierarchy.avid}
                onClick={() => this.setState({ selectedHierarchyAvid: hierarchy.avid })}
                active={this.state.selectedHierarchyAvid === hierarchy.avid}>
                <Badge color="light">{this.getAvidLength(hierarchy.avid)}</Badge>
                <span>{hierarchy.avidLabel}</span>
              </DataListRowLink>
            )}
          </DataList>
        </Col>
        <Col className="pt-3">
          <Row>
            {selectedSurveys.map((survey, index) =>
              <>
                {index % 2 === 0 &&
                  <div className="w-100" key={survey.surveyNewAbbreviation + 0}></div>
                }
                <Col key={survey.surveyNewAbbreviation + 1}>
                  <p>
                    <input type="checkbox"
                      id={survey.surveyNewAbbreviation}
                      onClick={() => this.togglePair(survey)}
                      checked={this.isChecked(survey)} />
                    <label htmlFor={survey.surveyNewAbbreviation}>
                      <span>{survey.surveyLabel}&nbsp;</span>
                      <span className="text-muted">({survey.surveyNewAbbreviation})</span>
                    </label>
                  </p>
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>
    )
  }
}
